import { Routes } from '@angular/router';
import { Oauth2Component } from './oauth2.component';

export const ROUTES_OAUTH2: Routes = [
    { path: 'authorize', component: Oauth2Component },
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' }
];